import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'styled-button',
  template: `
    <button 
      (click)="handleClick()" 
      [class]="'styled-button ' + variant + (disabled ? ' disabled' : '')"
    >
      <ng-content></ng-content>
    </button>
  `,
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {

  @Input() variant: string = "filled";
  @Input() disabled: boolean = false;

  @Output() onClick = new EventEmitter();

  handleClick() {
    if (this.disabled) return;

    this.onClick.emit();
  }

}
